export type ContactChannel = 'whatsapp' | 'phone' | 'email';

/**
 * The way a link reaches the store, or null when it isn't a contact link.
 * A WhatsApp link with no number is a share to someone of the visitor's
 * choosing, not a message to the store, so it doesn't count.
 */
export function contactChannel(href: string): ContactChannel | null {
  if (href.startsWith('tel:')) return 'phone';
  if (href.startsWith('mailto:')) return 'email';
  if (/^https?:\/\/wa\.me\/\d/.test(href)) return 'whatsapp';
  if (/^(https?:\/\/api\.whatsapp\.com\/send|whatsapp:\/\/send)\?(.*&)?phone=\d/.test(href)) {
    return 'whatsapp';
  }
  return null;
}
